export function isValidRelativePath(path?: string) {
  return typeof path === 'string' && (path === '' || path.charAt(0) === '/');
}

export function isValidAbsolutePath(path?: string) {
  return typeof path === 'string' && path.match('^https?://');
}



// WEBPACK FOOTER //
// ./src/actions/Navigation/helper.ts